import { render, staticRenderFns } from "./SummaryCards.vue?vue&type=template&id=20a5958f&scoped=true&lang=pug"
import script from "./SummaryCards.vue?vue&type=script&lang=ts"
export * from "./SummaryCards.vue?vue&type=script&lang=ts"
import style0 from "./SummaryCards.vue?vue&type=style&index=0&id=20a5958f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a5958f",
  null
  
)

export default component.exports